module.exports = __webpack_public_path__ + "assets/img/icon03.b5a58648.png";